module.exports = __webpack_public_path__ + "static/media/lock.2be57ca7.svg";